import React, { useEffect } from "react";
import { UrgencyBar, Hero, VideoSection, AboutAstrologer } from "../components/salespage/TopSections";
import { FinancialProblems } from "../components/salespage/FinancialSection";
import { WhatYouGet, TrustBadges, Showcase, SuccessStories } from "../components/salespage/MidSections";
import { Testimonials, CountdownBanner, FAQ, Footer, StickyBar, TermsConditions } from "../components/salespage/BottomSections";
import OrderForm from "../components/salespage/OrderForm";
import CallUsPopup from "../components/salespage/CallUsPopup";
import { useContent } from "../context/ContentContext";
import { Loader2 } from "lucide-react";

const SalesPage = () => {
  const { loading, error } = useContent();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "BruhatYoga Swarna Ratnam | Adrusta Ratnam";
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#5A0B1D] flex flex-col items-center justify-center gap-3">
        <Loader2 className="w-10 h-10 text-[#E9C767] animate-spin" />
        <p className="text-[#e9d7c0] font-marcellus tracking-wide">Loading your blessings...</p>
      </div>
    );
  }

  return (
    <div className="bg-[#FBF5E9] pb-16 md:pb-0">
      {error && (
        <div className="bg-amber-100 text-amber-800 text-center text-sm py-2 px-4">Showing saved content — live updates will resume shortly.</div>
      )}
      <UrgencyBar />
      <Hero />
      <VideoSection />
      <FinancialProblems />
      <AboutAstrologer />
      <WhatYouGet />
      <TrustBadges />
      <Showcase />
      <SuccessStories />
      <Testimonials />
      <CountdownBanner />
      <OrderForm />
      <FAQ />
      <TermsConditions />
      <Footer />
      <StickyBar />
      <CallUsPopup />
    </div>
  );
};

export default SalesPage;
